import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Reports.frontend.types'

@Injectable({ providedIn: 'root' })
export class Reports_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Reports: Reports_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
